import { GlobalError } from "~/types/types"

export const useErrorStore = defineStore('error', () => {
  const globalErrors = ref<GlobalError[]>([])

  const addGlobalError = (message: string) => {
    globalErrors.value.push({ message })
  }

  const hasGlobalError = (message: string) => {
    return globalErrors.value.some((error) => error.message === message)
  }

  const clearGlobalErrors = () => {
    globalErrors.value = []
  }

  return { globalErrors, addGlobalError, hasGlobalError, clearGlobalErrors }
})
